// extracted by mini-css-extract-plugin
export default {"heading":"LB-z","corrected":"MB-z","redirectVerbiageContainer":"NB-z","redirectVerbiageText":"OB-z"};